import repositories from '..';

const resource = '/integration/functions';

export default {
  getInitData: (data: any) => repositories.get(`${resource}/data/init?moduleId=${data}`),
};
